import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'wfdss-resources',
    templateUrl: './resources.component.html',
    styleUrls: ['./resources.component.scss'],
    standalone: false
})
export class ResourcesComponent implements OnInit {

  madcapResourceUrl = "https://doifirefighterlawenforcementtm.mcoutput.com/1379022/Content/Home.htm"
  
  constructor() { }

  ngOnInit() {
    window.open(this.madcapResourceUrl, '_blank');
  }

}
